import React from 'react'
import Meme from './components/Meme'

function App() {
    return (
    <div className='container'>
        <header>
            <h1>Meme Generator </h1>
        </header>
        <Meme />
    </div>
    )
}

export default App